import React from 'react';
import {withStyles} from '@material-ui/core';
import TableRow from '@material-ui/core/TableRow';
import isUrl from 'is-url';
import {string} from '../../i18n/yupLocaleDE';

const bySelector = (elem, selector) => {
    try {
        let items = elem.querySelectorAll('#' + selector); // try element by name
        if (items && items.length > 0) {
            items[0].click();
            return true;
        }
        else {
            items = elem.querySelectorAll('.' + selector); // try element by name
            if (items && items.length > 0) {
                items[0].click();
                return true;
            }
            else {
                items = elem.querySelectorAll(selector); // try element by external selector
                if (items && items.length > 0) {
                    items[0].click();
                    return true;
                }
            }
        }
    }
    catch ($ex) {
        console.error($ex);
    }
    return false;
};

const ClickableRow = (actionNrOrUrl, e) => {
    if (e && e.currentTarget && e.currentTarget.cells && e.currentTarget.cells.length > 0) {
        let elem = null;
        let items = null;
        if (!actionNrOrUrl) {
            actionNrOrUrl = 0;
        }
        if (typeof (actionNrOrUrl) === 'string' && (isUrl(actionNrOrUrl) || actionNrOrUrl.indexOf('/') === 0)) {
            window.location.href = actionNrOrUrl;
            return true;
        }
        for (let i = 0; i < e.currentTarget.cells.length; i++) {
            elem = e.currentTarget.cells[i];

            if (typeof (actionNrOrUrl) === 'string') {
                return bySelector(elem, actionNrOrUrl);
            }
            else {
                items = elem.querySelectorAll('a, button'); // try element by tag with number

                if (items && items.length > actionNrOrUrl) {
                    items[actionNrOrUrl].click();
                    return true;
                }
            }
        }
        return false;
    }
};

/**
 *
 * @param children
 * @param classes
 * @param action   Number or url to trigger, when number, it iterate through a and button elements using this number
 * @returns {*}
 * @constructor
 */
const TableRowClickable = ({children, classes, action}) => (
    <TableRow onClick={ClickableRow.bind(this, action)} className={classes.clickable}>
        {children}
    </TableRow>
);

const styles = theme => ({
    clickable: {
        cursor: 'pointer',
    },
});

export default withStyles(styles)(TableRowClickable);
